import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import RegisterForm from '../components/RegisterForm';
import { useAuth } from '../hooks/useAuth';
import './AuthPages.css';

/**
 * Page d'inscription
 */
const RegisterPage: React.FC = () => {
  const { isAuthenticated, isLoading, isNewUser } = useAuth();
  const navigate = useNavigate();
  
  // Rediriger si l'utilisateur est déjà connecté
  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      // Si c'est un nouvel utilisateur, rediriger vers la page de profil
      if (isNewUser) {
        navigate('/profile', { replace: true });
      } else {
        // Sinon, rediriger vers la page d'accueil
        navigate('/', { replace: true });
      }
    }
  }, [isAuthenticated, isLoading, isNewUser, navigate]);
  
  // Callback après inscription réussie
  const handleRegisterSuccess = () => {
    // Rediriger vers la page de profil après inscription
    navigate('/profile', { replace: true });
  };
  
  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <h1>EtuDown</h1>
          <p className="auth-subtitle">Créez votre compte pour rejoindre la communauté</p>
        </div>
        
        <RegisterForm onSuccess={handleRegisterSuccess} />
        
        <div className="auth-footer">
          <p>
            Vous avez déjà un compte ?{' '}
            <Link to="/login" className="auth-link">
              Connectez-vous
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
